import axios from 'axios'
import qs from 'qs'


// Экшены store гасят ошибки запросов через `console.error` и возвращают undefined, поэтому
// сбой сервера выглядит для пользователя как «ничего не произошло» — и он повторяет действие
// по уже неактуальному состоянию. Единая точка оповещения; обработчик ставит views/Index.vue
let unexpectedErrorHandler = null

export function setUnexpectedErrorHandler(handler) {
  unexpectedErrorHandler = handler
}

// TODO: do not serialize arrays to comma separated strings
const instance = axios.create({
  // xsrfCookieName: 'csrftoken',
  // xsrfHeaderName: 'X-CSRFToken'
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'comma' })
  }
})

instance.interceptors.response.use(null, error => {
  const data = error.response && error.response.data
  // `{ errors: {...} }` — ожидаемый прикладной отказ, его рисует форма
  // `{ error: 'offloadingActive' }` — у юзера уже выполняется offloading-задача, экшен подцепится к ней
  if( !data || (!data.errors && data.error !== 'offloadingActive') ) {
    if( unexpectedErrorHandler ) unexpectedErrorHandler(error)
  }
  return Promise.reject(error)
})

export default instance
